export const MODAL_ADD_PUBLICATION_TO_MAIN_PAGE_CONSTS = {
  exclusive: 'Эксклюзив',
  mainForTheDay: 'Главное за день',
  pictureOfTheDay: 'Картина дня',
  subtitle: 'Подзаголовок',
  title: 'Заголовок'
}
